<mat-toolbar class="chat-toolbar gap-1">
  <mat-icon class="cursor-pointer text-secondary" (click)="fecharChat()">arrow_back</mat-icon>
  <div class="chat-profile">
    @if (!!chat?.id) {
      <div class="avatar-wrapper">
        <chat-imagem [imagem]="chat?.capa">
        </chat-imagem>
      </div>
    }
    <div class="chat-info">
      @if (!!chat?.id) {
        <div class="chat-profile-name">
          {{chat.nome}}
        </div>
      }
      @if (!chat?.id) {
        <div class="chat-profile-name">
          Novo Chat
        </div>
      }
      @if (chat?.descricao?.length) {
        <div class="chat-descricao">
          {{chat.descricao}}
        </div>
      }
    </div>
  </div>
  @if (chat?.grupo) {
    <div class="chat-toolbar-actions"
      >
      <button mat-icon-button
        [matMenuTriggerFor]="chatMensagemMenu"
        aria-label="more">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #chatMensagemMenu="matMenu">
        @if (chat.grupo && chat.chatParticipante?.administrador) {
          <button mat-menu-item (click)="chatForm()">
            Alterar Chat
          </button>
        }
        @if (chat.grupo) {
          <button mat-menu-item (click)="chatParticipantes()">
            @if (chat.chatParticipante?.administrador) {
              <span>
                Gerenciar Membros
              </span>
            }
            @if (!chat.chatParticipante?.administrador) {
              <span>
                Visualizar Membros
              </span>
            }
          </button>
        }
        @if (chat.chatParticipante?.administrador && chat.grupo) {
          <button mat-menu-item
            (click)="excluirChat()">
            Excluir Chat
          </button>
        }
        @if (chat.grupo) {
          <button mat-menu-item
            (click)="sairChat()">
            Sair do Chat
          </button>
        }
      </mat-menu>
    </div>
  }
</mat-toolbar>
